var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphonesGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 100,
    viewBox: "0 0 104 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "3.772%",
    x2: "100%",
    y2: "96.228%",
    id: "jmx1xcyrma"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DBEFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD92FE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 52,
    cy: 63,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.81 25.14c20.057 0 36.317 16.757 36.317 37.43 0 20.671-16.26 37.43-36.32 37.43C31.75 99.998 15.49 83.241 15.49 62.57c0-20.67 16.26-37.43 36.32-37.43zm4.91 19.405-18.485 16.47a2.384 2.384 0 0 0-.643 2.596c.34.912 1.206 1.53 2.167 1.53h8.05l-5.552 13.19a2.378 2.378 0 0 0 .765 2.83 2.282 2.282 0 0 0 2.881-.132l18.485-16.47a2.384 2.384 0 0 0 .643-2.595 2.318 2.318 0 0 0-2.166-1.522h-8.051l5.552-13.198a2.378 2.378 0 0 0-.765-2.83 2.282 2.282 0 0 0-2.881.131zM52.186 0C65.765 0 78.755 5.216 89.94 14.854c1.153.994 1.491 2.609.942 3.96 7.974 8.644 12.891 19.97 13.111 32.405l.008.829V63.14c0 .817-.647 1.478-1.444 1.478-.279 0-.539-.08-.76-.22l.002 2.586c0 7.476-5.74 13.612-13.053 14.242 2.688-5.63 4.197-11.962 4.197-18.657 0-8.207-2.267-15.87-6.193-22.361h.753c6.308 0 11.662 4.086 13.56 9.756-.516-11.171-5.082-21.337-12.326-29.171a3.307 3.307 0 0 1-3.14-.665c-10.01-8.625-21.481-13.232-33.41-13.232-11.682 0-22.927 4.417-32.794 12.708a3.31 3.31 0 0 1-3.477.5C8.644 27.663 3.918 37.51 3.038 48.387c2.293-4.834 7.218-8.177 12.925-8.177h.905c-3.926 6.49-6.193 14.153-6.193 22.36 0 6.7 1.51 13.037 4.201 18.67-7.387-.554-13.21-6.725-13.21-14.255l.001-2.383a1.423 1.423 0 0 1-.223.017c-.75 0-1.367-.586-1.437-1.335L0 63.14V51.998c.024-13.2 5.34-25.192 14.008-34.124-.35-1.277.04-2.703 1.106-3.599C26.148 5.005 38.886 0 52.186 0z",
    fill: "url(#jmx1xcyrma)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesGradient);
export default __webpack_public_path__ + "static/media/headphones-gradient.81c6514d4e0b8d7782f714335ba85e7f.svg";
export { ForwardRef as ReactComponent };